export default __webpack_public_path__ + "static/media/about-us.9b8e89da.jpg";